/**
 * Created by akirilyuk on 9/20/16.
 */
define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var Loader = require("ui/loader/Loader");
    var TicketsSnippetsCompositeView = require("connection-views/ticketTab/TicketsSnippetsCompositeView");
    var TicketsSnippetsCompositeModel = require("connection-models/ticketTab/TicketsSnippetsCompositeModel");
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var TicketModel = require("connection-models/ticketTab/TicketModel");
    var HtmlSanitizerUtils = require("HtmlSanitizerUtils");

    var filterOptions = {
        accountID : TicketModel.KEYS.SITE_ID,
        status : TicketModel.KEYS.STATUS,
        accountName : TicketModel.KEYS.ACCOUNT_NAME,
        business : TicketModel.KEYS.ACCOUNT_TYPE,
        name: TicketModel.KEYS.CONTACT_NAME
    };
    var SearchFilterController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        SearchFilterController = Marionette.Controller.extend({

            initialize: function (options) {
                this.collection = options.collection;
                this.filterCollection = OrganizeCollectionDecorator.decorate(this.collection.getOriginalCollection());
                this.selectedValues = [];
                this.filterValues = this._thisInitOptionItems();
                this.initialOptionItems = this._createOptionsItems();
                this.filterLayout = options.filterLayout;
            },

            //init the optionItems of the Layout from the originalCollection
            _thisInitOptionItems: function(){
                return this._getOptions(this.collection.getOriginalCollection().models);
            },

            //--- GENERATE THE OPTION ITEMS ARRAY FROM COLLECTION AND REMOVE DUPLICATE
            _getOptions: function(collection){
                //extend simillary to clone
                var filterValues = $.extend(true,{},filterOptions);
                for(var value in filterValues){
                    filterValues[value] = this._getPossibleOptions(filterValues[value],collection);
                }
                return filterValues;
            },

            //get all unique possible options
            _getPossibleOptions: function(attribute,collection){
                var possibleOptions = [];
                _.each(collection,function(value){
                    if(value){
                        //check if the option is already in the possibleOptions
                        var keyValue = value.get(attribute);
                        if((_.indexOf(possibleOptions,keyValue)===-1)){
                            possibleOptions.push(keyValue);
                        }
                    }
                });
                return possibleOptions;
            },

            //create the option items object for the different input fields
            _createOptionsItems: function(){
                var optionsItems = {
                    accountid : this._getItems(this.filterValues.accountID),
                    accountName : this._getItems(this.filterValues.accountName),
                    business : this._getItems(this.filterValues.business),
                    status : this._getItems(this.filterValues.status),
                    name: this._getItems(this.filterValues.name)
                };
                return optionsItems;
            },

            getCurrentOptionItems: function(){
                return this.currentOptionItems;
            },

            getInitialOptionItems: function(){
                return this.initialOptionItems;
            },

            //-----GENERATE THE ITEMS
            _getItems: function(filterValues){
                var items = [];
                var that = this;
                _.each(filterValues,function(value,key){
                        //check if the item is in the selected Items, if yes check the selected box
                    var selected = (_.indexOf(that.selectedValues,value)>-1);
                    items.push({
                        id: key,
                        value : value,
                        selected : selected
                    });
                });
                return items;
            },
            filter: function(values){
                this._filter(values);
            },

            _filter: function(selectedItems){
                this.selectedValues = [];
                var filterInfoArray = [];
                //first get all the selected ItemsID and map them back to the Attribute Values
                var statusValues = selectedItems.statusValues;
                var accountNameValues = selectedItems.accountNameValues;
                var accountIdValues = selectedItems.accountIdValues;
                var businessValues = selectedItems.businessValues;
                var nameValues = selectedItems.nameValues;
                if (statusValues&&statusValues.length>0) {
                    filterInfoArray.push(this._generateFilterItems(filterOptions.status,this.filterValues.status,statusValues));
                }
                if(accountNameValues&&accountNameValues.length>0){
                    filterInfoArray.push(this._generateFilterItems(filterOptions.accountName,this.filterValues.accountName,accountNameValues));
                }
                if(accountIdValues&&accountIdValues.length>0){
                    filterInfoArray.push(this._generateFilterItems(filterOptions.accountID,this.filterValues.accountID,accountIdValues));
                }
                if(businessValues&&businessValues.length>0){
                    filterInfoArray.push(this._generateFilterItems(filterOptions.business,this.filterValues.business,businessValues));
                }
                if(nameValues&&nameValues.length>0){
                    filterInfoArray.push(this._generateFilterItems(filterOptions.name,this.filterValues.name,nameValues));
                }
                if(filterInfoArray.length>0){
                    //only track if there are selected values
                    this._trackFilterUsage(filterInfoArray);
                }

                var filterInfoModel = this._generateFilterInfoModel(filterInfoArray);
                //filter the passed collection
                this.collection.filterTickets(filterInfoModel);
                //filter intern collection to keep track of possible options

                this.filterCollection.organize(filterInfoModel);
                this.filterValues = this._getOptions(this.filterCollection.models);
                this.currentOptionItems = this._createOptionsItems();
                this.trigger("collection::filtered");
            },
            _getFilteringPredicate: function(filterInfoArray){
                return function(model){
                    var resultArray = [];
                    _.each(filterInfoArray,function(value){
                        if(value.values && value.values.length>0){
                            var match = false;
                            _.each(value.values,function(attributeValue){
                                if(model.get(value.attribute)===attributeValue){
                                    match = true;
                                }
                            });
                            resultArray.push(match);
                        }
                    });
                    if(resultArray.length>0){
                        //if the results doesn't contain false -> false -> !false -> true
                        return !(_.contains(resultArray,false));
                    }
                    //if nothing is set
                    return true;
                };
            },
            _generateFilterInfoModel: function(filterInfoArray){
                var predicate = this._getFilteringPredicate(filterInfoArray);
                var filterInfo = {
                    filterModel: {
                        predicate: predicate,
                        filteredWith: filterInfoArray
                    }
                };
                return filterInfo;
            },
            //map the selected item ids to the attributes, each id represents the place of the attribute in its subarray
            //of filter info
            _generateFilterItems: function(attribute,values,selectedValues){
                var filterItems = {
                    attribute : attribute,
                    values :[]
                };
                var that = this;
                _.each(selectedValues,function(value){
                    if(values){
                        if(values[value]){
                            var itemValue = values[value];
                            filterItems.values.push(itemValue);
                            //track the already selected items so the are displayd as selected in the filter view
                            that.selectedValues.push(itemValue);
                        }
                    }
                });
                return filterItems;
            },

            //USAGE TRACKING
            _trackFilterUsage: function (filterInfoArray) {
                var filterInfoString = this._generateFilterInfoString(filterInfoArray);
                filterInfoString = this._encodeURI(filterInfoString);
                if(LEConnection && LEConnection.media && LEConnection.media.channel){
                    LEConnection.media.channel(LE.mediaCodes.connection.channels.USAGE_TRACKING).vent.trigger("UsageTrackingController:track", {
                        slug: filterInfoString,
                        usageToTrack: CP_CONST.USAGE_TO_TRACK.MYCASES.FILTER_CASES
                    });
                }
            },
            _generateFilterInfoString: function (filterInfoArray) {
                var infoString = "[";
                _.each(filterInfoArray, function (value,index) {
                    infoString += "{" + '"' + value.attribute + '"' + ":";
                    var values = value.values;
                    _.each(values, function (attribute, key) {
                        if (key === 0) {
                            infoString += "[";
                        }
                        if (key < values.length - 1) {
                            infoString += '"' + attribute + '"' + ",";
                        }
                        if (key === values.length - 1) {
                            infoString += '"' + attribute + '"' + "]";
                        }
                    });
                    if(filterInfoArray.length>1 && (index+1)<filterInfoArray.length){
                        infoString += "},";
                    }else{
                        infoString += "}";
                    }
                });
                infoString += "]";
                return infoString;
            },
            _encodeURI: function (str) {
                return encodeURIComponent(str).replace(/'/g, "%27").replace(/"/g, "%22");
            }
        });
    });
    return SearchFilterController;
});
